import LastConfigurationsDateFilter from './LastConfigurationsDateFilter'
import lastConfigurationsDateFilterContainer from './lastConfigurationsDateFilterContainer'

export default lastConfigurationsDateFilterContainer(LastConfigurationsDateFilter)
